import React from 'react';

function NotFound() {
    return (
        <div className="flex h-screen items-center justify-center text-white">
          <p>Page not found. Please try again.</p>
        </div>
    );
}

export default NotFound;